'use strict';
import isUndefined from 'lodash/isUndefined';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import {stateGo} from 'redux-ui-router';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {animatedStateGo} from '../actions/router';
import {logger} from './logger';


export const epics = [
  onAnimatedStateGo,
];

onAnimatedStateGo.$inject = [
  '$ionicViewSwitcher',
];

/**
 * @param {ActionsObservable<ReduxAction>} action$
 * @param {Store} store
 * @param dependencies
 * @return {Observable<ReduxAction>}
 */
export function onAnimatedStateGo(action$, store, dependencies) {
  return action$.ofType(animatedStateGo.TYPE)
    .map(action => {
      dependencies.$ionicViewSwitcher.nextDirection(action.payload.direction);

      if (isUndefined(action.payload.params)) {
        return stateGo(action.payload.state);
      } else {
        return stateGo(action.payload.state, action.payload.params);
      }
    })
    .catch(epicErrorHandler(logger, 'onAnimatedStateGo'));
}



// WEBPACK FOOTER //
// ./src/js/app/epics/onAnimatedStateGo.js